import React, { useEffect, useState } from "react";
import axios from "axios";
import { GoogleMap, useJsApiLoader, Autocomplete } from '@react-google-maps/api';

const SubjectManager = () => {
  const [subjects, setSubjects] = useState([]);
  const [newSubject, setNewSubject] = useState({
  companyName: "",
  email: "",
  address: "",
  contactPerson: "",
  contactEmail: "",
  pib: "",
  lat: "",
  lng: "",
  phone: "",
  website: "",
  bankName: "",
  accountNumber: "",
  iban: "",
  swift: "",
});

  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  // Filtriraj subjekte
const filteredSubjects = subjects.filter((subj) =>
  `${subj.company_name} ${subj.pib} ${subj.address} ${subj.email}`
    .toLowerCase()
    .includes(searchQuery.toLowerCase())
);

  const getPlaceDetails = (placeId) => {
  const service = new window.google.maps.places.PlacesService(document.createElement('div'));
  return new Promise((resolve, reject) => {
    service.getDetails(
      {
        placeId,
        fields: ['name'], // Samo ime firme
      },
      (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          resolve(place);
        } else {
          reject(status);
        }
      }
    );
  });
};


 const handlePlaceChanged = async () => {
  if (autocomplete) {
    const place = autocomplete.getPlace();
    const address = place.formatted_address;
    const lat = place.geometry?.location?.lat();
    const lng = place.geometry?.location?.lng();
    const placeId = place.place_id;

    let updatedSubject = {
      ...newSubject,
      address: address || "",
      lat: lat || "",
      lng: lng || "",
    };

    try {
      const details = await getPlaceDetails(placeId);
      if (details.name) {
        updatedSubject.companyName = details.name;
      }
    } catch (err) {
      console.warn("❌ Nije moguće dobiti ime firme:", err);
    }

    setNewSubject(updatedSubject);
  }
};


  const fetchSubjects = async () => {
    try {
      const res = await axios.get("https://modularobjects.com/checkout/api/subjects");
      setSubjects(res.data);
    } catch (err) {
      console.error("Greška pri preuzimanju subjekata:", err);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  const handleChange = (e) => {
    setNewSubject({ ...newSubject, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
   setNewSubject({
  companyName: "",
  email: "",
  address: "",
  contactPerson: "",
  contactEmail: "",
  pib: "",
  lat: "",
  lng: "",
  phone: "",
  website: "",
  bankName: "",
  accountNumber: "",
  iban: "",
  swift: ""
});
    setEditingId(null);
    setIsEditing(false);
  };

  const handleSubmit = async () => {
    if (!newSubject.companyName || !newSubject.pib || !newSubject.email) {
      setMessage("Popunite obavezna polja: naziv firme, PIB i email.");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const isEmailValid = /\S+@\S+\.\S+/.test(newSubject.email);
    if (!isEmailValid) {
      setMessage("Unesite validan email.");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const isValidIban = /^[A-Z]{2}[0-9A-Z]{15,30}$/.test(newSubject.iban);
if (newSubject.iban && !isValidIban) {
  setMessage("IBAN format nije ispravan.");
  window.scrollTo({ top: 0, behavior: "smooth" });
  return;
}

const isValidSwift = /^[A-Z0-9]{8}([A-Z0-9]{3})?$/.test(newSubject.swift);
if (newSubject.swift && !isValidSwift) {
  setMessage("SWIFT kod nije ispravan.");
  window.scrollTo({ top: 0, behavior: "smooth" });
  return;
}

const isValidAccount = /^[0-9]{8,20}$/.test(newSubject.accountNumber);
if (newSubject.accountNumber && !isValidAccount) {
  setMessage("Broj računa nije ispravan.");
  window.scrollTo({ top: 0, behavior: "smooth" });
  return;
}

if (newSubject.iban?.trim() && !isValidIban) {
  setMessage("IBAN format nije ispravan.");
  window.scrollTo({ top: 0, behavior: "smooth" });
  return;
}


    try {
      if (isEditing && editingId !== null) {
        await axios.put(`https://modularobjects.com/checkout/api/subjects/${editingId}`, newSubject);
        setMessage("Uspešno izmenjeno!");
      } else {
        await axios.post("https://modularobjects.com/checkout/api/subjects", newSubject);
        setMessage("Uspešno dodat!");
      }
      resetForm();
      fetchSubjects();
    } catch (err) {
      console.error("Greška:", err);
      setMessage("Greška pri slanju.");
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Upravljanje subjektima</h1>


      <div className="mb-6 space-y-2">
        <input name="companyName" placeholder="Ime firme" className="border p-2 w-full" value={newSubject.companyName} onChange={handleChange} />
        <input name="email" placeholder="Email" className="border p-2 w-full" value={newSubject.email} onChange={handleChange} />
        <Autocomplete onLoad={setAutocomplete} onPlaceChanged={handlePlaceChanged}>
          <input name="address" placeholder="Adresa" className="border p-2 w-full" value={newSubject.address} onChange={handleChange} />
        </Autocomplete>
        <input name="contactPerson" placeholder="Kontakt osoba" className="border p-2 w-full" value={newSubject.contactPerson} onChange={handleChange} />
        <input name="contactEmail" placeholder="Kontakt email" className="border p-2 w-full" value={newSubject.contactEmail} onChange={handleChange} />
        <input name="pib" placeholder="PIB" className="border p-2 w-full" value={newSubject.pib} onChange={handleChange} />
        <input name="phone" placeholder="Telefon" className="border p-2 w-full" value={newSubject.phone} onChange={handleChange} />
        <input name="website" placeholder="Web sajt" className="border p-2 w-full" value={newSubject.website} onChange={handleChange} />
        <input name="bankName" placeholder="Naziv banke" className="border p-2 w-full" value={newSubject.bankName} onChange={handleChange} />
        <input name="accountNumber" placeholder="Broj računa" className="border p-2 w-full" value={newSubject.accountNumber} onChange={handleChange} />
        <input name="iban" placeholder="IBAN" className="border p-2 w-full" value={newSubject.iban} onChange={handleChange} />
        <input name="swift" placeholder="SWIFT kod" className="border p-2 w-full" value={newSubject.swift} onChange={handleChange} />

        <div className="flex items-center gap-4">
          <button onClick={handleSubmit} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
            {isEditing ? "Sačuvaj izmene" : "Dodaj subjekat"}
          </button>
          {isEditing && (
            <button onClick={resetForm} className="text-sm text-gray-600 hover:text-black">
              Otkaži izmenu
            </button>
          )}
        </div>
        {message && <p className="text-green-600">{message}</p>}
      </div>

      <h2 className="text-xl font-semibold mb-2">Lista subjekata</h2>

<input
  type="text"
  placeholder="Pretraga subjekata..."
  value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)}
  className="mb-4 w-full h-10 border rounded px-4 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
/>

<div className="overflow-x-auto">
  <table className="min-w-full border text-sm bg-white dark:bg-neutral-900">
   <thead>
  <tr className="bg-gray-100 dark:bg-neutral-800">
    <th className="p-2 border whitespace-nowrap">Firma</th>
    <th className="p-2 border whitespace-nowrap">Email</th>
    <th className="p-2 border whitespace-nowrap">Adresa</th>
    <th className="p-2 border whitespace-nowrap">PIB</th>
    <th className="p-2 border whitespace-nowrap">Telefon</th>
    <th className="p-2 border whitespace-nowrap">Banka</th>
    <th className="p-2 border whitespace-nowrap">Web</th>
    <th className="p-2 border whitespace-nowrap">Osoba</th>
    <th className="p-2 border whitespace-nowrap">Kontakt</th>
    <th className="p-2 border whitespace-nowrap">Račun</th>
    <th className="p-2 border whitespace-nowrap">IBAN</th>
    <th className="p-2 border whitespace-nowrap">SWIFT</th>
    <th className="p-2 border whitespace-nowrap">Akcije</th>
  </tr>
</thead>
    <tbody>
  {filteredSubjects.map((subj) => (
    <tr key={subj.id} className="hover:bg-gray-50 dark:hover:bg-neutral-800">
      <td className="border p-2 whitespace-nowrap">{subj.company_name}</td>
      <td className="border p-2 whitespace-nowrap">{subj.email}</td>
      <td className="border p-2 whitespace-nowrap">{subj.address}</td>
      <td className="border p-2 whitespace-nowrap">{subj.pib}</td>
      <td className="border p-2 whitespace-nowrap">{subj.phone}</td>
      <td className="border p-2 whitespace-nowrap">{subj.bank_name}</td> {/* pre Web */}
      <td className="border p-2 whitespace-nowrap">
        {subj.website ? (
          <a
            href={subj.website}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            {subj.website}
          </a>
        ) : (
          "-"
        )}
      </td>
      <td className="border p-2 whitespace-nowrap">{subj.contact_person}</td>
      <td className="border p-2 whitespace-nowrap">{subj.contact_email}</td>
      <td className="border p-2 whitespace-nowrap">{subj.account_number}</td>
      <td className="border p-2 whitespace-nowrap">{subj.iban}</td>
      <td className="border p-2 whitespace-nowrap">{subj.swift}</td>
      <td className="border p-2 whitespace-nowrap">
        <button
          onClick={() => {
            setEditingId(subj.id);
            setIsEditing(true);
            setNewSubject({
              companyName: subj.company_name,
              email: subj.email,
              address: subj.address,
              pib: subj.pib,
              contactPerson: subj.contact_person,
              contactEmail: subj.contact_email,
              lat: subj.lat || "",
              lng: subj.lng || "",
              phone: subj.phone || "",
              website: subj.website || "",
              bankName: subj.bank_name || "",
              accountNumber: subj.account_number || "",
              iban: subj.iban || "",
              swift: subj.swift || "",
            });
          }}
          className="text-blue-600 hover:underline"
        >
          Izmeni
        </button>
      </td>
    </tr>
  ))}
</tbody>
  </table>
</div>
</div>
  );
};

export default SubjectManager;